// extracted by mini-css-extract-plugin
export var footerDisclaimer = "styles-module--footerDisclaimer--68c6b";